export default "__VITE_ASSET__Dg32WuH6__"